import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { BaseView, BaseText } from '@/components/base'
import { PaymentMethodItemTransferIn } from './PaymentMethodItemTransferIn'
// import { SelectPaymentMethodModal } from '@/components/SelectPaymentMethodModal'
import type { PaymentMethodsType } from '@/constants/paymentMethods'
import { useGetPaymentMethodsWithWallet } from '@/hooks'
import type { PaymentMethodType } from '@/types/sendRequest'
import type { CryptoCode } from '@/constants/currencyCodes'

interface PaymentMethodSelectorTransferInProps {
  selectedMethod: PaymentMethodType['paymentMethod']
  onMethodChange: (method: PaymentMethodType['paymentMethod']) => void
  hasEnoughBalance?: boolean
  disabled?: boolean
  paymentMethodsListCustom?: PaymentMethodsType[]
  shouldDisplayCurrencyIcon?: boolean
  currencyCode?: CryptoCode
}

export const PaymentMethodSelectorTransferIn: React.FC<
  PaymentMethodSelectorTransferInProps
> = ({
  selectedMethod,
  onMethodChange,
  hasEnoughBalance = true,
  disabled = false,
  paymentMethodsListCustom,
  shouldDisplayCurrencyIcon = false,
  currencyCode = 'USDT',
}) => {
  const { t } = useTranslation()
  const [isModalOpen, setIsModalOpen] = useState(false)

  // Get payment methods with wallet data if currency code provided
  const paymentMethodsWithWallet = useGetPaymentMethodsWithWallet({
    currencyCode,
  })
  const paymentMethods = paymentMethodsListCustom || paymentMethodsWithWallet
  const hasOnlyOnePaymentMethod = paymentMethods.length === 1

  const [selectedPaymentMethodState, setSelectedPaymentMethodState] =
    useState<PaymentMethodsType>(
      paymentMethods.find(
        ({ paymentMethod }) => paymentMethod === selectedMethod,
      ) || paymentMethods[0],
    )

  useEffect(() => {
    // Update selected method when it changes externally
    const newSelected = paymentMethods.find(
      ({ paymentMethod }) => paymentMethod === selectedMethod,
    )
    if (newSelected) {
      setSelectedPaymentMethodState(newSelected)
    }
  }, [selectedMethod, paymentMethods])

  const handleSelectPaymentMethod = (method: PaymentMethodsType) => {
    setSelectedPaymentMethodState(method)
    onMethodChange(method.paymentMethod)
    setIsModalOpen(false)
  }

  const openModal = () => {
    if (!disabled) {
      setIsModalOpen(true)
    }
  }

  return (
    <>
      <BaseView gap={12}>
        <BaseText fontSize={16} color="label.default">
          {t('translation:paymentMethod')}
        </BaseText>

        {selectedPaymentMethodState && (
          <PaymentMethodItemTransferIn
            {...selectedPaymentMethodState}
            onPress={openModal}
            isDisabled={disabled}
            hasOnlyOnePaymentMethod={hasOnlyOnePaymentMethod}
          />
        )}
      </BaseView>

      {/* Modal for selecting payment method */}
      {/* <SelectPaymentMethodModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={t('screens:confirmAddMoney.selectPaymentMethod')}
        paymentMethods={paymentMethods}
        selectedPaymentMethod={selectedPaymentMethodState}
        onSelectPaymentMethod={handleSelectPaymentMethod}
        hasEnoughBalance={hasEnoughBalance}
        disabled={disabled}
        shouldDisplayCurrencyIcon={shouldDisplayCurrencyIcon}
      /> */}
    </>
  )
}

export default PaymentMethodSelectorTransferIn
